// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__WtPh_","radioRow":"SimpleQuestionBuilderModal_radioRow__3OKhG"};